import { z } from "zod";

export const GenerationErrorCode = z.enum([
  // note: taken from OpenAI API error codes
  "server_error",
  "rate_limit_exceeded",
  "invalid_prompt",
  "vector_store_timeout",
  "invalid_image",
  "invalid_image_format",
  "invalid_base64_image",
  "invalid_image_url",
  "image_too_large",
  "image_too_small",
  "image_parse_error",
  "image_content_policy_violation",
  "invalid_image_mode",
  "image_file_too_large",
  "unsupported_image_media_type",
  "empty_image_file",
  "failed_to_download_image",
  "image_file_not_found",

  // additional custom and OpenAI codes
  "invalid_api_key",
  "invalid_request_error",
  "empty_response",
]);

export type GenerationErrorCode = z.infer<typeof GenerationErrorCode>;

export const GenerationErrorResponse = z.object({
  code: GenerationErrorCode.describe("A response error code"),
  message: z.string().describe("A message giving more details about the failure"),
});

export type GenerationErrorResponse = z.infer<typeof GenerationErrorResponse>;
